import React, { Fragment, memo } from 'react';
import { withRouter } from 'react-router-dom';
import TablaFiltro from '../../../components/UI/tablaFiltro/tablaFiltroSort.jsx';
import Botones from '../../../components/UI/botonera/headerBotones.js';

function PresupuestoInt(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botonDet}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <TablaFiltro
                            columnas={props.columnas}
                            datos={props.listaPresupuestos}
                            keyField={"ID"}
                            modo={props.cellEdit}
                            selectRow={props.selectRow}
                            condensed={false}
                            borrar={false}
                            busqueda={true}
                            nombreCSV={"Presupuesto"}
                            conFiltro={true}
                            subTituloBotones={""}
                        />
                    </div>
                </div>
                <div className='d-none'>
                    <input type='file' id='ArchivoCarga' ref={props.hiddenFileInput} onChange={props.cargaArchivoExcel} />
                </div>
            </div>
        </Fragment>
    );
}
export default withRouter(memo(PresupuestoInt));